module.exports = __webpack_public_path__ + "static/media/test-auditif-audioprothese.8b2a2881.png";